import { render, staticRenderFns } from "./TableMonitorDetail.vue?vue&type=template&id=0d8109bd&scoped=true&"
import script from "./TableMonitorDetail.vue?vue&type=script&lang=js&"
export * from "./TableMonitorDetail.vue?vue&type=script&lang=js&"
import style0 from "./TableMonitorDetail.vue?vue&type=style&index=0&id=0d8109bd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8109bd",
  null
  
)

export default component.exports